module.exports = __webpack_public_path__ + "static/media/postcard_germany.828bd304.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/postcard_germany.jpg
// module id = 466
// module chunks = 0